import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    deleteDailyTool,
    DeleteDailyToolResponse,
    createDailyTool,
    DailyToolResponse,
    updateDailyTool,
    UpdateDailyToolBody,
    UpdateDailyToolQueries,
    DeleteDailyToolQueries,
} from '../../services/apiSLTP/dailyReports/dailyTools';

type UseDeleteDailyToolMutationOptions = MutationOptions<DeleteDailyToolResponse, Error, { id: string; queries?: DeleteDailyToolQueries }>;

export const useDeleteDailyToolMutation = (options?: UseDeleteDailyToolMutationOptions) => {
    const deleteDailyToolMutation: MutationFunction<DeleteDailyToolResponse, { id: string; queries?: DeleteDailyToolQueries }> = async ({
        id,
        queries,
    }) => {
        try {
            const response: DeleteDailyToolResponse = await deleteDailyTool(id, queries);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during delete daily tool');
        }
    };

    return useMutation(deleteDailyToolMutation, options);
};

type UseCreateDailyToolMutationOptions = MutationOptions<
    DailyToolResponse,
    Error,
    { activityId: string; toolId: string; state: number; isUsed: boolean; createTransfer?: boolean; quantity?: number }
>;

export const useCreateDailyToolMutation = (options?: UseCreateDailyToolMutationOptions) => {
    const createDailyToolMutation: MutationFunction<
        DailyToolResponse,
        { activityId: string; toolId: string; state: number; isUsed: boolean; createTransfer?: boolean; quantity?: number }
    > = async ({ activityId, toolId, state, isUsed, createTransfer, quantity }) => {
        try {
            const response: DailyToolResponse = await createDailyTool(activityId, toolId, state, createTransfer, undefined, undefined, quantity);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during create daily tool');
        }
    };

    return useMutation(createDailyToolMutation, options);
};

type UseDailyToolMutationOptions = MutationOptions<
    DailyToolResponse,
    Error,
    { id: string; body: UpdateDailyToolBody; queries?: UpdateDailyToolQueries }
>;

export const useDailyToolMutation = (options?: UseDailyToolMutationOptions) => {
    const updateDailyToolMutation: MutationFunction<
        DailyToolResponse,
        { id: string; body: UpdateDailyToolBody; queries?: UpdateDailyToolQueries }
    > = async ({ id, body, queries }) => {
        try {
            const response: DailyToolResponse = await updateDailyTool(id, body, queries);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during update daily tool');
        }
    };

    return useMutation(updateDailyToolMutation, options);
};
